// App1.js - Fixed version with comprehensive error handling
import React, { useState } from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import download from '../../../Assets/images/download.png'
import Receipt from './Receipt';
import './receipt.css'

export function numberInWords(price) {
  // Validate input
  if (!price || isNaN(price)) return '';
  
  const sglDigit = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const dblDigit = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tensPlace = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  
  const handle_tens = function(dgt, prevDgt) {
    return dgt === 0 ? "" : " " + (dgt === 1 ? dblDigit[prevDgt] : tensPlace[dgt]);
  };
  
  const handle_utlc = function(dgt, nxtDgt, denom) {
    return (dgt !== 0 && nxtDgt !== 1 ? " " + sglDigit[dgt] : "") + (nxtDgt !== 0 || dgt > 0 ? " " + denom : "");
  };

  let str = "";
  let digitIdx = 0;
  let digit = 0;
  let nxtDigit = 0;
  const words = [];
  
  const priceStr = String(price);
  
  if (isNaN(parseInt(priceStr))) {
    str = "";
  } else if (parseInt(priceStr) > 0 && priceStr.length <= 10) {
    for (digitIdx = priceStr.length - 1; digitIdx >= 0; digitIdx--) {
      digit = parseInt(priceStr[digitIdx]);
      nxtDigit = digitIdx > 0 ? parseInt(priceStr[digitIdx - 1]) : 0;
      
      switch (priceStr.length - digitIdx - 1) {
        case 0:
          words.push(handle_utlc(digit, nxtDigit, ""));
          break;
        case 1:
          words.push(handle_tens(digit, parseInt(priceStr[digitIdx + 1])));
          break;
        case 2:
          words.push(digit !== 0 ? " " + sglDigit[digit] + " Hundred" + (parseInt(priceStr[digitIdx + 1]) !== 0 && parseInt(priceStr[digitIdx + 2]) !== 0 ? " and" : "") : "");
          break;
        case 3:
          words.push(handle_utlc(digit, nxtDigit, "Thousand"));
          break;
        case 4:
          words.push(handle_tens(digit, parseInt(priceStr[digitIdx + 1])));
          break;
        case 5:
          words.push(handle_utlc(digit, nxtDigit, "Lakh"));
          break;
        case 6:
          words.push(handle_tens(digit, parseInt(priceStr[digitIdx + 1])));
          break;
        case 7:
          words.push(handle_utlc(digit, nxtDigit, "Crore"));
          break;
        case 8:
          words.push(handle_tens(digit, parseInt(priceStr[digitIdx + 1])));
          break;
        case 9:
          words.push(digit !== 0 ? " " + sglDigit[digit] + " Hundred" + (parseInt(priceStr[digitIdx + 1]) !== 0 || parseInt(priceStr[digitIdx + 2]) !== 0 ? " and" : " Crore") : "");
          break;
        default:
          break;
      }
    }
    str = words.reverse().join("");
  } else {
    str = "";
  }
  return str.trim();
}

const App1 = ({ receipt, type }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const company = {
    name: type === "repayment" ? "MONK CAPITAL PVT LTD" : "Feepay",
    address: `The Platina, B-406, Sy No. 132, 134, H. No. 4-50/1, Gachibowli, K.V.Rangareddy, Seri Lingampally, Telangana, India, 500032`,
    iacgAddress: `Nandini Complex, Dilsukh Nagar Main Rd, beside Vijaya Diagnostic centre, Indira Nagar, Dilsukhnagar, Hyderabad, Telangana 500036`,
    apolloAddress: `8-2-293/82/A/501P, 4th Floor, SBR Arcade,Road No.36, Jublee Hills,Hyderabad, Telangana, India – 500033`,
    ushodayaAddress: `Attapur, Rambagh Colony, Hyderabad, Telangana 500064`,
    joyAddress: `G9W4+8R9, Mallampet Rd, Bachupally, Hyderabad, Telangana 500090`,
    indicAddress: `SY No 116, Cine Planet, Lane, opp. Siddh Convention, Satyam Enclave, Kompally, Hyderabad, Telangana 500014`
  };

  // Safe URL parsing
  let logo = "";
  try {
    const urlParams = window?.location?.href?.split('?')[1];
    if (urlParams) {
      const params = urlParams.split('&');
      const logoParam = params.find(param => param.includes('='));
      if (logoParam) {
        logo = logoParam.split('=')[1] || "";
      }
    }
  } catch (err) {
    console.warn('Error parsing URL parameters:', err);
    logo = "";
  }

  // Validate receipt object
  if (!receipt) {
    console.error('Receipt object is undefined');
    return (
      <div style={{ color: 'red', padding: '10px' }}>
        Error: Receipt data not available
      </div>
    );
  }

  let user = {};
  let receiptNo = '';
  let date = '';
  let fileName = '';

  // Safe data extraction with proper validation
  try {
    switch (type) {
      case "feepayment":
        const paidAmount = receipt.paid_amount ? parseFloat(receipt.paid_amount) : 0;
        user = {
          username: receipt.studentName || 'N/A',
          LoanID: receipt.txnId || receipt.txnid || 'N/A',
          loanType: receipt.payment_name || 'N/A',
          amount: paidAmount,
          paymentMethod: receipt.paymentMode || 'N/A',
          bank: receipt.bankName || "NA",
          branch: receipt.bankBranch || "NA",
          amountInWords: numberInWords(paidAmount),
          dateOfPayment: receipt.paid_date || new Date().toISOString().split('T')[0],
        };
        receiptNo = receipt.txnid || receipt.txnId || 'N/A';
        date = receipt.paid_date || new Date().toISOString().split('T')[0];
        fileName = `Receipt_${(receipt.studentName || 'Unknown').replace(/[^a-zA-Z0-9]/g, '_')}_${date}.pdf`;
        break;

      case "repayment":
        const repaidAmount = receipt.repaidEmiAmount ? parseFloat(receipt.repaidEmiAmount) : 0;
        user = {
          username: receipt.firstname || 'N/A',
          amount: repaidAmount,
          amountInWords: numberInWords(repaidAmount),
          emiNo: receipt.emiNo || 'N/A',
          dateOfPayment: receipt.emiRepaidDate || new Date().toISOString().split('T')[0],
        };
        receiptNo = receipt.emiId || 'N/A';
        date = receipt.emiRepaidDate || new Date().toISOString().split('T')[0];
        fileName = `Receipt_${(receipt.firstname || 'Unknown').replace(/[^a-zA-Z0-9]/g, '_')}_${date}.pdf`;
        break;

      default:
        console.error('Unknown receipt type:', type);
        user = {
          username: 'N/A',
          LoanID: 'N/A',
          loanType: 'N/A',
          amount: 0,
          amountInWords: 'Zero',
          dateOfPayment: new Date().toISOString().split('T')[0],
        };
        receiptNo = 'N/A';
        date = new Date().toISOString().split('T')[0];
        fileName = 'Receipt_Unknown.pdf';
        break;
    }
  } catch (err) {
    console.error('Error processing receipt data:', err);
    setError('Error processing receipt data');
    return (
      <div style={{ color: 'red', padding: '10px' }}>
        Error: Failed to process receipt data
      </div>
    );
  }

  // Enhanced error handling for PDFDownloadLink
  const handleDownloadError = (error) => {
    console.error('PDF Download Error:', error);
    setError('Error generating PDF. Please try again.');
    setIsGenerating(false);
  };

  const handleDownloadStart = () => {
    setIsGenerating(true);
    setError(null);
  };

  if (error) {
    return (
      <div style={{ color: 'red', padding: '10px' }}>
        {error}
        <button 
          onClick={() => setError(null)} 
          style={{ marginLeft: '10px', padding: '5px' }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      <PDFDownloadLink 
        document={<Receipt company={company} user={user} receiptNo={receiptNo} date={date} logo={logo} />} 
        fileName={fileName}
        onError={handleDownloadError}
        onClick={handleDownloadStart}
      >
        {({ blob, url, loading, error }) => {
          if (error) {
            console.error('PDF Generation Error:', error);
            handleDownloadError(error);
            return (
              <div style={{ color: 'red' }}>
                Error generating PDF
              </div>
            );
          }
          
          return type === "feepayment" ? (
            <div style={{ display: 'flex', paddingTop: '1em', cursor: 'pointer' }}>
              <div>
                <img 
                  style={{ width: '20px', height: '20px', marginLeft: '1em' }} 
                  src={download} 
                  alt="Download PDF"
                  onError={(e) => {
                    console.error('Download icon failed to load');
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          ) : (
            <img 
              style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
              src={download} 
              alt="Download PDF"
              onError={(e) => {
                console.error('Download icon failed to load');
                e.target.style.display = 'none';
              }}
            />
          );
        }}
      </PDFDownloadLink>
    </>
  );
};

export default App1;